import { createFileRoute } from "@tanstack/react-router";
import { ZenBackground } from "@/components/ZenBackground.tsx";
import { useEffect } from "react";
import { useUserStore } from "@/stores/useUserStore.ts";

export const Route = createFileRoute("/auth/logout")({
  component: RouteComponent,
  head: () => ({
    meta: [{ title: "Logging Out | Eedi Tutor Dashboard" }],
  }),
});

function RouteComponent() {
  const { Logout } = useUserStore();

  useEffect(() => {
    Logout(true);
  }, [Logout]);

  return <ZenBackground></ZenBackground>;
}
